import React, { ChangeEvent, FC, useCallback, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/lib/react';
import { AutoComplete, Icon, Text, theme } from '@mtsbank/ui-kit';
import { Payee } from '@root/api/ump-catalog-manager';
import { searchChangeGtm, serviceSearchClickGtm } from '@root/utils/gtm/cyber/events';
import search from '@asserts/images/cyber/Search.svg';
import useCategoryServices from '@root/hooks/useCategoryServices';
import { ICON_TCP } from '../Cyber/constansts';
interface ICyberAutoComplete {
  servicesAllServer?: Payee[];
}
export const CyberAutoComplete: FC<ICyberAutoComplete> = ({
  servicesAllServer
}) => {
  const [suggestions, setSuggestions] = useState<Payee[]>([]);
  const [selectedValue, setSelectedValue] = useState({
    value: ''
  });
  const [isMounted, setIsMounted] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const router = useRouter();
  const {
    servicesAll,
    fetchCategoryData
  } = useCategoryServices();
  useEffect(() => {
    setIsMounted(true);
    if (!servicesAllServer?.length) {
      fetchCategoryData();
    }
    return () => {
      setIsMounted(false);
    };
  }, [fetchCategoryData, servicesAllServer]);
  const fetchSuggestions = (query: string) => new Promise<void>(resolve => {
    const filteredPayees = servicesAllServer ? servicesAllServer?.filter(payee => payee.providerName?.toLowerCase().includes(query.toLowerCase())) : servicesAll?.filter(payee => payee.providerName?.toLowerCase().includes(query.toLowerCase()));
    if (isMounted) {
      resolve(setSuggestions(filteredPayees));
    }
  });
  const getSuggestionValue = (payee: Payee) => payee.providerName;
  const handleValueClear = () => {
    setSelectedValue({
      value: ''
    });
  };
  const handleChangeValue = ({
    currentTarget: {
      value
    }
  }: ChangeEvent<HTMLInputElement>) => {
    setSelectedValue({
      ...selectedValue,
      value
    });
    if (value) {
      searchChangeGtm(value);
    }
  };
  const inputProps = {
    placeholder: 'Поиск по сайту',
    value: selectedValue.value,
    isClearable: true,
    onClear: handleValueClear,
    onChange: handleChangeValue,
    ref: inputRef,
    // onBlur: (event) => {
    //   if (event.target.value) {
    //     searchChangeGtm(event.target.value as string)
    //   }
    // },
    controlChildren: <Icon isCustomIcon icon={search} />
  };
  const renderSuggestion = useCallback((payee: Payee) => {
    const {
      icon,
      providerName
    } = payee;
    const tspIcon = icon ? `${ICON_TCP}/${icon}` : null;
    return <TspWrapper>
        {tspIcon && <IconTsp src={tspIcon} />}
        <Text color="white">{providerName}</Text>
      </TspWrapper>;
  }, []);
  const onSuggestionSelected = useCallback(({
    features,
    providerName
  }: Payee) => {
    serviceSearchClickGtm(providerName);
    router.push(`/${features?.tsp_url}`);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.blur();
      }
    }, 0);
    setSelectedValue({
      ...selectedValue,
      value: ''
    });
  }, [router, selectedValue]);
  return <SearchInputWrapper id="search">
      <AutoComplete<Payee> debounce debounceDelay={900} inputProps={inputProps} suggestions={suggestions} fetchSuggestions={fetchSuggestions} renderSuggestion={renderSuggestion} getSuggestionValue={getSuggestionValue} onSuggestionSelected={onSuggestionSelected} variant="privateBanking" />
    </SearchInputWrapper>;
};
const SearchInputWrapper = /*#__PURE__*/styled("div")({
  name: "SearchInputWrapper",
  class: "s55wxcf"
});
const TspWrapper = /*#__PURE__*/styled("div")({
  name: "TspWrapper",
  class: "t1btngk4"
});
const IconTsp = /*#__PURE__*/styled("img")({
  name: "IconTsp",
  class: "irg76di"
});

require("./CyberAutoComplete.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./CyberAutoComplete.tsx");